import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import "./style.css";

function CustomDropDownToggle({ isOpen, toggle }) {
    return (
        <div className={`custom-collapse-toggle ${isOpen ? "open" : ""}`}>
            <ArrowDropDownIcon onClick={toggle} />
        </div>
    );
}

export default CustomDropDownToggle;